import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickMutation } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IUserPassword } from "./routeType";

const { key, getPath } = getApi("users.password.change.post");

type IExtractedRouteType = IUserPassword["loggedInUserSinglePasswordUpdate"];

export type IChangeLoggedInUserPassword = IPickMutation<IExtractedRouteType>;

const changeLoggedInUserPassword: Fetcher<
  IChangeLoggedInUserPassword["response"],
  IChangeLoggedInUserPassword["variables"]
> = (data) => {
  return axiosClient.post(getPath(), data);
};

export const useChangeLoggedInUserPassword = createQuery({
  queryKey: [key],
  fetcher: changeLoggedInUserPassword,
});
